import { defineAction } from '~/prix'
import residenceImageDeleteAction from './residenceImageDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const residenceImageDeleteDefinition = defineAction({
  ...residenceImageDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default residenceImageDeleteDefinition
